import * as React from 'react';

import LoadingIndicator from 'components/atoms/LoadingIndicator';
import classes from './ProductGridState.scss';

export type ProductGridViewState = 'initial-loading' | 'initial-error' | 'empty' | 'content';

type Props = {
  viewState: ProductGridViewState;
  message?: string | null;
  emptyContent?: React.ReactNode;
};

const DEFAULT_ERROR_MESSAGE = 'データ取得に失敗しました。時間をおいて再度お試しください。';

export const getProductGridViewState = (
  status: 'idle' | 'loading' | 'succeeded' | 'error',
  itemsLength: number
): ProductGridViewState => {
  if (status === 'loading' && itemsLength === 0) {
    return 'initial-loading';
  }
  if (status === 'error' && itemsLength === 0) {
    return 'initial-error';
  }
  if (status === 'succeeded' && itemsLength === 0) {
    return 'empty';
  }
  return 'content';
};

const ProductGridState: React.FC<Props> = ({ viewState, message, emptyContent }) => {
  if (viewState === 'initial-loading') {
    return (
      <div className={classes['state']}>
        <LoadingIndicator />
      </div>
    );
  }

  if (viewState === 'initial-error') {
    const resolvedMessage = message ?? DEFAULT_ERROR_MESSAGE;
    return (
      <div className={classes['state']}>
        <p className={`${classes['state__message']} ${classes['state__message--error']}`}>{resolvedMessage}</p>
      </div>
    );
  }

  if (viewState === 'empty') {
    if (emptyContent) {
      return <div className={classes['state']}>{emptyContent}</div>;
    }
    if (message) {
      return (
        <div className={classes['state']}>
          <p className={`${classes['state__message']} ${classes['state__message--empty']}`}>{message}</p>
        </div>
      );
    }
  }

  return null;
};

export default ProductGridState;
